import {
  SET_INS_CAR_NAME,
  SET_DIAGNOSIS,
  SET_PROCEDURE,
  SET_MODIFIER,
} from "store/actions/actionTypes";
import { setErrorMessage } from "store/actions/appActions";
import axios from "axios";
import { billing } from "store/requests";

export const getProcedureSuccess = (procedure) => {
  return {
    type: SET_PROCEDURE,
    procedure,
  };
};

export const getProcedure = (payload) => {
  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/getProcedure",
        payload,
      });
      dispatch(getProcedureSuccess(response.data));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("im canceled", error.message);
      } else {
        dispatch(
          setErrorMessage(error?.response?.data?.error || error.message),
        );
      }
      console.log("ERROR", error.response);
    }
  };
};

export const getInsCarrierSuccess = (ins_car_name) => {
  return {
    type: SET_INS_CAR_NAME,
    ins_car_name,
  };
};

export const getInsCarrier = (payload) => {
  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/getPayerMaster",
        payload,
      });
      dispatch(
        getInsCarrierSuccess(
          response.data?.map((c) => ({
            ...c,
            fullText: `${c.payer_id} ${c.payer_name}`,
          })),
        ),
      );
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("im canceled", error.message);
      } else {
        dispatch(
          setErrorMessage(error?.response?.data?.error || error.message),
        );
      }
    }
  };
};

export const getDiagnosisSuccess = (diagnosis) => {
  return {
    type: SET_DIAGNOSIS,
    diagnosis,
  };
};

export const getDiagnosis = (payload) => {
  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/getDiagnosis",
        payload,
      });
      dispatch(getDiagnosisSuccess(response.data));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("im canceled", error.message);
      } else {
        dispatch(
          setErrorMessage(error?.response?.data?.error || error.message),
        );
      }
    }
  };
};

export const getModifierSuccess = (modifier) => {
  return {
    type: SET_MODIFIER,
    modifier,
  };
};

export const getModifier = (payload) => {
  return async (dispatch) => {
    try {
      let response = await billing({
        url: "/getModifier",
        payload,
      });
      dispatch(getModifierSuccess(response.data));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log("im canceled", error.message);
      } else {
        dispatch(
          setErrorMessage(error?.response?.data?.error || error.message),
        );
      }
    }
  };
};
